import React, { useCallback } from "react";
import { Checkbox as MaterialCheckbox } from "@material-ui/core";
import styles from "./checkbox.module.scss";
import classNames from "classnames";

const Checkbox = ({ value = false, onChange, name, disabled, checked }) => {
  const onChangeCb = useCallback(() => {
    if (onChange) {
      onChange(name, {
        value: !value,
      });
    }
  }, [name, value, onChange]);

  return (
    <div
      className={classNames({
        [`${styles.disabled}`]: disabled,
      })}
    >
      <MaterialCheckbox
        className={styles.checkbox}
        checked={value === "indeterminate" ? null : value || checked}
        indeterminate={value === "indeterminate"}
        disabled={disabled}
        onChange={onChangeCb}
      />
    </div>
  );
};

export default Checkbox;
